// import axios from "axios";
import {localAxios as axios} from "../../../index";
import {API_URL} from "../../../utils/apiURLs";

// Summary
export function getBalanceSummary(params) {
  return axios.get(API_URL.BALANCE_SUMMARY, {params});
}

// SalesList
export function getSalesList(params) {
  return axios.get(`${API_URL.BALANCE_SALES_LIST}`, {params});
}

// excel download
export function getExcelDownload(params) {
  return axios.get(`${API_URL.BALANCE_EXCEL_DOWNLOAD}`, {params});
}
